import { render, staticRenderFns } from "./price-list.vue?vue&type=template&id=3815d338&"
import script from "./price-list.vue?vue&type=script&lang=js&"
export * from "./price-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3815d338')) {
      api.createRecord('3815d338', component.options)
    } else {
      api.reload('3815d338', component.options)
    }
    module.hot.accept("./price-list.vue?vue&type=template&id=3815d338&", function () {
      api.rerender('3815d338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b5iJXE26a1kS/JS/comp/price-list.vue"
export default component.exports